import { Wizard } from "react-use-wizard";
import Content from "../Content";
import Footer from "../Footer";
import ImageWithCaption from "../ImageWithCaption";
import CoinbaseCreateImg from "../assets/Coinbase/Wallet/Frame02.png";
import Recovery from "../assets/Coinbase/Wallet/Frame03.png";
import Import from "../assets/Coinbase/Wallet/Frame04.png";
import CoinbasePassword from "../assets/Coinbase/Wallet/Frame05.png";

import ExtensionCard from "../ExtensionCard";
import { StepProps } from "../Metamask/MetamaskCreate";

const CoinbaseAdd: React.FC<StepProps> = ({ prevState, setFlowState }) => {
  return (
    <Wizard
      footer={
        <Footer
          prevState={prevState}
          setFlowState={setFlowState}
          currentState="coinbaseAdd"
        />
      }>
      <Content title="Download the Coinbase extension on Google Chrome, and open it.">
        <ExtensionCard wallet="cb" />
      </Content>
      <Content
        title={
          <>
            <span className="font-normal">Select </span>
            <span className="text-coinage-blue">I already have a wallet.</span>
          </>
        }>
        <ImageWithCaption
          src={CoinbaseCreateImg}
          caption="Image: Coinbase"
          altText="Adding coinbase wallet image"
        />
      </Content>
      <Content
        title={
          <>
            <span className="font-normal">Select </span>
            <span className="text-coinage-blue">Enter recovery phrase.</span>
          </>
        }
        description="I can’t find my recovery phrase"
        tooltipContent={{
          title: "Recovery Phrase Tip",
          description: (
            <>
              If you can’t find your recovery phrase, you need to make a new
              wallet. Create a new wallet{" "}
              <button
                className="underline"
                onClick={() =>
                  setFlowState({
                    prev: "initial",
                    current: "createWalletIntro"
                  })
                }>
                here.
              </button>
            </>
          )
        }}>
        <ImageWithCaption
          src={Recovery}
          caption="Image: Coinbase"
          altText="Adding coinbase wallet image"
        />
      </Content>
      <Content
        title={
          <>
            <span className="font-normal">
              Enter your 12 word recovery phrase. Then select{" "}
            </span>
            <span className="text-coinage-blue">Import wallet.</span>
          </>
        }
        description="I can’t find my recovery phrase"
        tooltipContent={{
          title: "Recovery Phrase Tip",
          description: (
            <>
              If you can’t find your recovery phrase, you need to make a new
              wallet. Create a new wallet
              <button
                className="underline"
                onClick={() =>
                  setFlowState({
                    prev: "initial",
                    current: "createWalletIntro"
                  })
                }>
                here.
              </button>
            </>
          )
        }}>
        <ImageWithCaption
          src={Import}
          caption="Image: Coinbase"
          altText="Adding coinbase wallet image"
        />
      </Content>
      <Content
        title="Create a password."
        description={
          <>
            Agree to the terms and privacy policy, and select{" "}
            <span className="text-coinage-blue font-bold w-full">Submit.</span>
          </>
        }>
        <ImageWithCaption
          src={CoinbasePassword}
          caption="Image: Coinbase"
          altText="Adding coinbase wallet image"
        />
      </Content>
    </Wizard>
  );
};

export default CoinbaseAdd;
